// @flow
import * as React from 'react';

const UserIcon = (props: *) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 360 360"
    {...props}
  >
    <defs>
      <path
        id="a"
        d="M342.4 309.9c0-62.7-51-113.7-113.7-113.7h-97.4c-62.7 0-113.7 51-113.7 113.7v32.5h324.8v-32.5zm-292.3 0c0-44.8 36.4-81.2 81.2-81.2h97.4c44.8 0 81.2 36.4 81.2 81.2H50.1z"
      />
    </defs>
    <clipPath id="b">
      <use xlinkHref="#a" overflow="visible" />
    </clipPath>
    <path
      clipPath="url(#b)"
      fill="currentColor"
      d="M-83.9 94.8h527.7v349.1H-83.9z"
    />
    <defs>
      <path
        id="c"
        d="M261.2 98.8c0-44.8-36.4-81.2-81.2-81.2S98.8 54 98.8 98.8 135.2 180 180 180s81.2-36.4 81.2-81.2m-129.9 0c0-26.9 21.9-48.7 48.7-48.7s48.7 21.9 48.7 48.7-21.9 48.7-48.7 48.7-48.7-21.8-48.7-48.7"
      />
    </defs>
    <clipPath id="d">
      <use xlinkHref="#c" overflow="visible" />
    </clipPath>
    <path
      clipPath="url(#d)"
      fill="currentColor"
      d="M-2.7-83.9h365.4v365.4H-2.7z"
    />
  </svg>
);

export default UserIcon;



// WEBPACK FOOTER //
// ./src/pages/__components__/UserIcon.js